import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Modal,
    Form,
    Popup,
    Icon,
    Input,
    Checkbox,
    Message,
    Dropdown,
    Grid
} from "semantic-ui-react";
import { selectedClients, fetchTaskTypeLookUp, fetchAllClients, fetchLocationLookUp, fetchClientTypeLookUp, fetchGroupLookUp } from ".././../../actions/clients/fetchAllClients";
import { bindActionCreators } from "redux";
import {
    createNotification,
    NOTIFICATION_TYPE_SUCCESS
} from "react-redux-notify";
import setDropdownValues from "../../../Common/Utility/setDropdownValues";
import DEFAULTS from "../../../Constants/lookupDefaultValues";
import { saveEdits } from "./../../../actions/clients/saveEdits";
import { bool, number, PropTypes, string } from "prop-types";
import moment from "moment";
import { showLoader } from "./../../../actions/clients/showLoader";
import { colHeaders } from "./../../../Constants/clients/colHeaders";
import { showNotification, notificationTypes } from "../../../Common/Notification/showNotification";

try {
    var userDetails = atob(localStorage.getItem("userDetails"));

    if (userDetails) {
        userDetails = JSON.parse(userDetails);
    }
} catch (e) {
    window.location.reload();
}

//Check globale user
var BRANCH_ID = null;
var RIGHT_ACCESS = null;
var MODULE_ID = null;

let GLOBAL_USER = "N";
if (RIGHT_ACCESS == 1 && MODULE_ID == 8) {
    GLOBAL_USER = "Y";
}

BRANCH_ID = userDetails.UserContext.locationId;

var FIRM_ID = userDetails ? userDetails.UserContext.firmId : 847;
var logginedUser = userDetails.UserContext.userId;
var lookup = { "clientGroups": Object, "taskTypes": Object, "locations": Object, "clientTypes": Object, "clientStatus": Object };

class BulkEdit extends Component {
    constructor(props) {
        lookup = new Object();
        super(props);
        this.state = {
            isOpen: props.shouldModalOpen,
            selectedFirmBranchesId: GLOBAL_USER === "Y" ? "" : BRANCH_ID,
            selectedprimaryTaskTypeIds: "",
            selectedClientTypeId: "",
            selectedClientStatusId: "",
            selectedLocationId: "",
            fiscalYear: "",
            selectedGroupIds: []
        };

    }

    componentDidMount() {
        this.props.fetchGroupLookUp(FIRM_ID)
            .then((res) => {
                lookup.clientGroups = res.payload.clientGroups.clientGroups
            });

        this.props.fetchTaskTypeLookUp(FIRM_ID)
            .then((res) => {
                lookup.taskTypes = res.payload.primaryTaskTypes.taskType
            });

        this.props.fetchLocationLookUp(FIRM_ID)
            .then((res) => {
                lookup.locations = res.payload.locations.firmBranch
            });

        this.props.fetchClientTypeLookUp()
            .then((res) => {
                lookup.clientTypes = res.payload.clientTypes.clientType
            });

        lookup.clientStatus = [{ id: "1", name: "Active" }, { id: "2", name: "Inactive" }]

    }

    onCancel() {
        this.props.toggleBulkEditForm();
        this.resetState();
    }

    resetState() {
        this.setState({
            selectedFirmBranchesId: GLOBAL_USER === "Y" ? "" : BRANCH_ID,
            selectedprimaryTaskTypeIds: "",
            selectedClientTypeId: "",
            selectedClientStatusId: "",
            selectedLocationId: "",
            fiscalYear: "",
            selectedGroupIds: []
        });
    }

    isValidTextInput(input) {
        return input != null && input.trim().length > 0;
    }

    mapClientProperties(elem, updatedDataObj, mapForTable) {
        let primaryTaskLookup, clientTypeLookup, locationLookup;

        let primaryTaskCode = this.isValidTextInput(updatedDataObj.primary_Task_Type) ? updatedDataObj.primary_Task_Type : (this.isValidTextInput(elem.primaryTaskCode) ? elem.primaryTaskCode.split('(')[0].trim() : "");

        if (this.isValidTextInput(primaryTaskCode)) {
            primaryTaskLookup = lookup.taskTypes.filter(el => el.code === primaryTaskCode || el.name === primaryTaskCode)[0];
        } 

        if (this.isValidTextInput(updatedDataObj.Client_Type)) {
            clientTypeLookup = lookup.clientTypes.filter(el => el.clientTypeName === updatedDataObj.Client_Type)[0];
            elem.clientTypeId = clientTypeLookup.id
        } else if (!elem.clientTypeId) {
            clientTypeLookup = lookup.clientTypes.filter(el => el.clientTypeName === elem.clientType)[0];
            elem.clientTypeId = clientTypeLookup.id
        }

        if (this.isValidTextInput(updatedDataObj.location_Id)) {
            locationLookup = lookup.locations.filter(el => el.branchName === updatedDataObj.location_Id)[0]
            elem.branchId = locationLookup.branchID
        } else if (!elem.branchId) {
            locationLookup = lookup.locations.filter(el => el.branchName === elem.branchName)[0]
            elem.branchId = locationLookup.branchID
        }

        let isActive = this.isValidTextInput(updatedDataObj.Client_Status) ? (updatedDataObj.Client_Status == "Active" ? "Y" : "N") : elem.active == "Active" ? "Y" : "N";
        let clientGroups = [];
        let groupNameConcat = "";        
        var grpNames = updatedDataObj.Group_Names && updatedDataObj.Group_Names.length > 0 ? updatedDataObj.Group_Names : (elem.groupName ? elem.groupName.split("|").map(v => v.split("-")[0].trim()) : []);
        var GrpDetails = { "CGS_GroupID": number, "groupName": string, "CGS_Client_ID": number, "GroupNumber": string, "CGS_FirmID": number, "CGS_BranchID": number, "Active": string };
        for (var i = 0; i < grpNames.length; i++) {
            if (grpNames[i].trim() != "NONE") {
                let group = this.props.clientGroups ? this.props.clientGroups.filter(el => el.groupName.trim() == grpNames[i].trim())[0] : null;
                GrpDetails = new Object();
                GrpDetails.CGS_GroupID = group?.groupId ?? 0;
                GrpDetails.GroupName = grpNames[i].trim();
                GrpDetails.CGS_Client_ID = elem.clientId;
                GrpDetails.CGS_FirmID = FIRM_ID;
                GrpDetails.CGS_BranchID = elem.branchId;
                GrpDetails.Active = isActive;
                clientGroups.push(GrpDetails);

                var name = group?.groupName + (group?.groupNumber?.length > 0 ? (" - " + group.groupNumber) : "");
                groupNameConcat = groupNameConcat.length > 0 ? (groupNameConcat + "|" + name) : name;
            }
        }

        elem.groupName = groupNameConcat.length > 0 ? groupNameConcat : elem.groupName;

        if (!elem.fullName)
            elem.fullName = elem.last_CorporateName;
        if (!elem.accountNumber)
            elem.accountNumber = "";
        if (!elem.phoneNumber)
            elem.phoneNumber = "";
        if (!elem.emailId)
            elem.emailId = "";
        if (!elem.firstName)
            elem.firstName = "";
        if (!elem.middleName)
            elem.middleName = "";
        if (!elem.generationType)
            elem.generationType = "";
        if (!elem.cparesponsibleId)
            elem.cparesponsibleId = 0;

        if (mapForTable) {
            if (primaryTaskLookup) {
                elem.primaryTaskName = primaryTaskLookup.name;
                elem.primaryTaskCode = primaryTaskLookup.code;
                elem.primaryTask = primaryTaskLookup.id;
            }                
            if (clientTypeLookup)
                elem.clientType = clientTypeLookup.clientTypeName;
            if (locationLookup)
                elem.branchName = locationLookup.branchName;

            elem.active = this.isValidTextInput(updatedDataObj.Client_Status) ? updatedDataObj.Client_Status : elem.active;
            elem.fiscalYear = this.isValidTextInput(updatedDataObj.fiscal_year) ? updatedDataObj.fiscal_year : elem.fiscalYear;
            elem.selected = false;
        } else {
            if (primaryTaskLookup) {
                elem.primaryTaskID = primaryTaskLookup.id
            }
            
            elem.firmID = FIRM_ID;
            elem.updated_by = logginedUser;
            elem.originatingLocationName = elem.branchName;
            elem.originatingLocation = elem.branchId;
            elem.active = isActive;
            elem.fiscalYear = this.isValidTextInput(updatedDataObj.fiscal_year) ? updatedDataObj.fiscal_year + "/" + new Date().getFullYear() : elem.fiscalYear ? (elem.fiscalYear.split("/").length == 3 ? elem.fiscalYear : elem.fiscalYear + "/" + new Date().getFullYear()) : "1/1/1900";
            elem.clientGroups = clientGroups;
        }
            
        return elem;
    }

    async onUpdateChanges() {
        if (this.state.selectedprimaryTaskTypeIds.length == 0 &&
            this.state.selectedClientTypeId.length == 0 &&
            this.state.selectedClientStatusId.length == 0 &&
            this.state.selectedLocationId.length == 0 &&
            this.state.selectedGroupIds.length == 0 &&
            this.state.fiscalYear.length == 0) {
            const notifyMsg = {
                message: `There are no changes to update.`,
                ...this.errorNotification
            };
            this.showAlertMessage(notifyMsg.message, false, true);
            return;
        } else if (this.state.fiscalYear.length > 0 && !this.isValidDate(this.state.fiscalYear, true))
            return;

        var updatedDataObj = {
            clientIds: this.props.selectedClientsIds,
            primary_Task_Type: this.state.selectedprimaryTaskTypeIds,
            Client_Type: this.state.selectedClientTypeId,
            Client_Status: this.state.selectedClientStatusId,
            location_Id: this.state.selectedLocationId,
            Group_Names: this.state.selectedGroupIds,
            fiscal_year: this.getFormatedDate(this.state.fiscalYear),
            selectedClientsData: this.props.clients.filter(({ clientId }) => this.props.selectedClientsIds.includes(clientId))
        }
        
        await this.updateData(updatedDataObj);
    }

    async updateData(updatedDataObj) {        
        var updatedClients = updatedDataObj.selectedClientsData
            .map((client) => {
                return this.mapClientProperties(Object.assign({}, client), updatedDataObj);
            });

        this.props.showLoader(true, "Please wait. Changes are being saved.");        
        let response = await this.props.saveEdits(updatedClients);
        
        if (response.payload.clientsReportData && response.payload.clientsReportData.isSuccess) {
            updatedDataObj.selectedClientsData.forEach((client) => {
                this.mapClientProperties(client, updatedDataObj, true);
            });
            this.props.selectedClients([]);           
            this.props.showNotification(response.payload.clientsReportData.msg, notificationTypes.SUCCESS);
        } else {
            this.props.showNotification(response.payload.clientsReportData.msg, notificationTypes.ERROR);
        }

        this.resetSelectAllCheckbox();
        this.resetState();
        this.props.toggleBulkEditForm();
        this.props.showLoader(false);
    }

    resetSelectAllCheckbox() {
        colHeaders[1] = "<input type='checkbox' class='checker htCheckboxRendererInput' data-row='-1' data-col='0' title='Select Up to first 50' />";
    }

    resetState() {
        this.setState({
            //isOpen: props.shouldModalOpen,
            selectedFirmBranchesId: GLOBAL_USER === "Y" ? "" : BRANCH_ID,
            selectedprimaryTaskTypeIds: "",
            selectedClientTypeId: "",
            selectedClientStatusId: "",
            selectedLocationId: "",
            fiscalYear: "",
            selectedGroupIds: []
        });
    }

    onprimaryTaskTypesChange(event, data) {
        let selectedprimaryTaskTypeIds = data.value;
        this.setState({
            selectedprimaryTaskTypeIds
        });
    }

    onGroupChange(event, data) {
        let selectedGroupIds = data.value;
        this.setState({
            selectedGroupIds
        });

    }

    onClientTypeChange(event, data) {
        let selectedClientTypeId = data.value;
        this.setState({
            selectedClientTypeId
        });
    }

    onClientStatusChange(event, data) {
        let selectedClientStatusId = data.value;
        this.setState({
            selectedClientStatusId
        });
    }

    getFormatedDate(input) {
        if (input == null || input.length == 0 || input =="") return input;
        let inputAry = input.split("/");
        return ("0" + inputAry[0]).slice(-2) + "/" + ("0" + inputAry[1]).slice(-2)
    }

    isValidDate(input, showErrorMessage) {
        if (input == null || input.length == 0) return true;
        let inputAry = input.split("/");
        let isValid = inputAry.length == 2 && moment((inputAry[0].length == 1 ? ("0" + inputAry[0]).slice(-2) : inputAry[0]) + "/" + (inputAry[1].length == 1 ? ("0" + inputAry[1]).slice(-2) : inputAry[1]) + "/" + new Date().getFullYear(), "MM/DD/YYYY", true).isValid();        
        if (showErrorMessage && !isValid) {
            const notifyMsg = {
                message: `Invalid fiscal year format. Accepted format is MM/DD`,
                ...this.errorNotification
            };
            this.showAlertMessage(notifyMsg.message, false, true);
        }

        return isValid;
    }

    onFiscalYearChange(event) {
        if (this.isValidDate(event.currentTarget.value, true)) {
            event.currentTarget.parentElement.parentElement.classList.remove("error");
        } else {
            event.currentTarget.parentElement.parentElement.classList.add("error");
        }
        this.setState({ fiscalYear: event.currentTarget.value });
    }

    onLocationChange(event, data) {
        let selectedLocationId = data.value;
        this.setState({
            selectedLocationId
        });
    }

    showAlertMessage(msg, isSuccessMessage, isForPopup) {
        let selector = (isForPopup ? ".modal " : "") + (isSuccessMessage ? '.positive' : '.negative');
        const elem = document.querySelector(selector);
        if (elem != null) {
            elem.style.visibility = 'visible';
            elem.innerText = msg;
            setTimeout(() => {
                elem.style.visibility = 'hidden';
            }, 5000);
        }
    }

    render() {
        return (
            <Modal

                className={"bulkEditModal"}
                centered={true}
                open={this.props.shouldModalOpen}>
                <Modal.Header>
                    <Grid columns={2}>
                        <Grid.Row>
                            <Grid.Column width={14}>
                                <h2> Bulk Edit</h2>
                            </Grid.Column>
                            <Grid.Column width={2} style={{ textAlign: "right" }}>
                                <Icon
                                    className="xcm-icon-close size-24"
                                    style={{ cursor: "pointer" }}
                                    onClick={this.onCancel.bind(this)}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Header>
                <Modal.Content>
                    <Form>
                        <Grid columns={4}>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <Form.Field>
                                        <label> Primary Task Type </label>
                                    </Form.Field>
                                </Grid.Column>
                                :
                                <Grid.Column width={5}>

                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        value={this.state.selectedprimaryTaskTypeIds}
                                        selection
                                        className={this.state.selectedprimaryTaskTypeIds.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "taskTypes",
                                                    properties: { id: "id", value: "name", text: "name" },
                                                },
                                                "fromClientBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onprimaryTaskTypesChange.bind(this)}
                                    />

                                </Grid.Column>
                                <Grid.Column width={2}>Group</Grid.Column>
                                :
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        multiple
                                        selection
                                        value={this.state.selectedGroupIds}
                                        className={this.state.selectedGroupIds.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "clientGroups",
                                                    properties: { id: "id", value: "name", text: "name,groupNumber" },
                                                },
                                                "fromClientBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onGroupChange.bind(this)}
                                    />

                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <label> Client/Entity Type</label>
                                </Grid.Column>
                                :
                                <Grid.Column width={5}>

                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        value={this.state.selectedClientTypeId}
                                        selection
                                        className={this.state.selectedClientTypeId.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "clientTypes",
                                                    properties: { id: "id", value: "name", text: "name" },
                                                },
                                                "fromClientBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onClientTypeChange.bind(this)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={2}>Active/Inactive</Grid.Column>
                                :
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        value={this.state.selectedClientStatusId}
                                        selection
                                        className={this.state.selectedClientStatusId.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "clientStatus",
                                                    properties: { id: "id", value: "name", text: "name" },
                                                },
                                                "fromClientBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onClientStatusChange.bind(this)} />

                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>Originating Location</Grid.Column>
                                :
                                <Grid.Column width={5}>
                                    <Dropdown
                                        fluid
                                        placeholder="Select"
                                        search
                                        clearable
                                        value={this.state.selectedLocationId}
                                        selection
                                        className={this.state.selectedLocationId.length ? "edited" : ""}
                                        options={
                                            setDropdownValues(
                                                {
                                                    data: lookup,
                                                    defaults: DEFAULTS,
                                                    selector: "locations",
                                                    properties: { id: "id", value: "name", text: "name" },
                                                },
                                                "fromClientBulkEdit"
                                            ) || []
                                        }
                                        onChange={this.onLocationChange.bind(this)}
                                    />
                                </Grid.Column>
                                <Grid.Column width={2}>Fiscal Year End</Grid.Column>
                                :
                                <Grid.Column width={5}>
                                    <Form.Field>
                                        <Input
                                            fluid
                                            name="fiscalYear"
                                            placeholder="mm/dd"
                                            className={this.state.fiscalYear.length ? "edited" : ""}
                                            onBlur={this.onFiscalYearChange.bind(this)}
                                        />
                                    </Form.Field>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Form>
                </Modal.Content>

                <Modal.Actions> 
                    <div id="buttons" >
                            <Grid padded textAlign="right">
                            <Grid.Row columns={2}>
                                <Grid.Column textAlign="left" width={10}>
                                    <Message negative className="visibilityHidden mt-0 pt-10 pb-10"></Message>
                                    </Grid.Column>
                                <Grid.Column width={6}>
                                    <Button
                                        content="Cancel"
                                        onClick={this.onCancel.bind(this)}
                                    />
                                    <Button
                                        content="Update"
                                        primary
                                        onClick={this.onUpdateChanges.bind(this)}
                                    />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                    </div>
                </Modal.Actions>               
            </Modal>
        );
    }
}


function mapStateToProps(state) {
    return {
        clients: state.allClients.clients,
        selectedClientsIds: state.allClients.selectedClients.selectedClientsIds,
        taskTypes: state.allClients.primaryTaskTypes,
        locations: state.allClients.locations,
        clientTypes: state.allClients.clientTypes,
        clientGroups: state.allClients.groupNames,
        clientStatus: state.allClients.statuses
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            selectedClients,
            createNotification,
            fetchTaskTypeLookUp,
            fetchAllClients,
            fetchLocationLookUp,
            fetchClientTypeLookUp,
            fetchGroupLookUp,
            saveEdits,
            showLoader,
            showNotification
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BulkEdit);
